import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Buefy from "buefy";
import "firebaseui-ja/dist/firebaseui.css";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import VueClipBoard from "vue-clipboard2";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import VEmojiPicker from "v-emoji-picker";
import marked from "marked";

library.add(fas, far);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(Buefy, { defaultIconPack: "fas" });
Vue.use(VueClipBoard);
Vue.component("v-emoji-picker", VEmojiPicker);
Vue.component(VueQrcode.name, VueQrcode);

Vue.filter("marked", (input: string) => {
  return marked(input);
});

//Vue.component('vue-fontawesome', FontAwesomeIcon)

Vue.config.productionTip = false;

Vue.use(Buefy, {
  defaultIconPack: "fas",
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
